/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_IntroInputs */

const en_pwf_intro = /** @type {(inputs: Pwf_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch this product to another workflow. Its items move to the statuses you choose below; nothing changes until you confirm.`)
};

const de_pwf_intro = /** @type {(inputs: Pwf_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechsle dieses Produkt zu einem anderen Workflow. Die Vorgänge wandern in die Status, die du unten wählst. Erst mit deiner Bestätigung ändert sich etwas.`)
};

/**
* | output |
* | --- |
* | "Switch this product to another workflow. Its items move to the statuses you choose below; nothing changes until you confirm." |
*
* @param {Pwf_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_intro = /** @type {((inputs?: Pwf_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_intro(inputs)
	return en_pwf_intro(inputs)
});